'use client'

import { Fragment } from 'react'
import {
  Box,
  Divider,
  Stack,
  Typography,
} from '@mui/material'
import { StyledEndMatter } from './endMatter.styles'
import Link from '@biolumina/ui/components/link/link'
import { BaseImage } from '@biolumina/ui/components/baseImage/baseImage'
import { useGlobalState } from '@biolumina/ui/context/globalStateProvider'

export const EndMatter = () => {
  const {
    siteData: { footerLinks, code, copy, date },
  } = useGlobalState()

  const [month, year] = date.split('/')

  return (
    <StyledEndMatter>
      <Box className="wrapper">
        <Link
          className="logo"
          data-tracking="footer-home-logo"
          style={{ display: 'block' }}
          href={'https://www.nuvationbio.com/'}
          target="_blank"
          external
        >
          <BaseImage
            src="/images/logo-nuvation.svg"
            width="150"
            height="26"
            sx={{ width: '150px', margin: '0 auto' }}
            alt="Nuvation Bio® logo"
          />
        </Link>

        <Stack
          direction={{ xs: 'column', md: 'row' }}
          divider={<>
            <Divider sx={{ bgcolor: 'text.primary', display: { xs: 'block', md: 'none' } }} orientation="horizontal" />
            <Divider sx={{ bgcolor: 'text.primary', display: { xs: 'none', md: 'block' } }} orientation="vertical" flexItem />
          </>}
          mb={2}
          justifyContent="center"
          spacing={2}
        >
          {footerLinks.slice(0, 5).map(({ display, ...link }, index, links) => (
              <Link key={link.href} variant="endMatter" data-tracking="footer-utility-nav-item" {...link}>
                {display}
              </Link>
          ))}
        </Stack>
        <Box sx={{ maxWidth: '623px' }} mx="auto">
          <Typography className="copy" mb={3}>
            This product information is intended for US residents only.
          </Typography>

          <Typography className="copy" mb={0}>
            {copy}
          </Typography>
          <Typography className="copy">
            &copy; 2026 NUVATION BIO INC. ALL RIGHTS RESERVED.{' '}
            <nobr>{code}</nobr>{' '}
            <Typography variant="span">
              {month}
            </Typography>
            /{year}
          </Typography>
        </Box>
      </Box>
    </StyledEndMatter>
  )
}
